/* tslint:disable */
/* eslint-disable */
/**
 * cro-fiona-search
 * Fiona Search Service
 *
 * The version of the OpenAPI document: 1.0.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Result,
    SavingsOfferRequest,
    SpecialOfferRequest,
} from '../models';

export interface PreviewControllerGetLoanPreviewRequest {
    purpose?: PreviewControllerGetLoanPreviewPurposeEnum;
    amount?: number;
    creditScore?: PreviewControllerGetLoanPreviewCreditScoreEnum;
    zipcode?: string;
}

export interface PreviewControllerGetSavingsPreviewRequest {
    savingsOfferRequest: SavingsOfferRequest;
}

export interface PreviewControllerGetSpecialPreviewRequest {
    specialOfferRequest: SpecialOfferRequest;
}

/**
 * PreviewControllerApi - interface
 *
 * @export
 * @interface PreviewControllerApiInterface
 */
export interface PreviewControllerApiInterface {
    /**
     *
     * @param {'debt_consolidation' | 'credit_card_refi' | 'home_improvement' | 'large_purchases' | 'auto_purchase' | 'auto_refinance' | 'baby' | 'boat' | 'business' | 'car_repair' | 'cosmetic' | 'emergency' | 'engagement' | 'green' | 'home_purchase' | 'home_refi' | 'household_expenses' | 'life_event' | 'medical_dental' | 'motorcycle' | 'moving_relocation' | 'rv' | 'special_occasion' | 'student_loan' | 'student_loan_refi' | 'taxes' | 'vacation' | 'wedding' | 'other'} [purpose]
     * @param {number} [amount]
     * @param {'excellent' | 'good' | 'fair' | 'poor'} [creditScore]
     * @param {string} [zipcode]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreviewControllerApiInterface
     */
    previewControllerGetLoanPreviewRaw(requestParameters: PreviewControllerGetLoanPreviewRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Result>>;

    /**
     */
    previewControllerGetLoanPreview(requestParameters: PreviewControllerGetLoanPreviewRequest, initOverrides?: RequestInit): Promise<Result>;

    /**
     *
     * @param {SavingsOfferRequest} savingsOfferRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreviewControllerApiInterface
     */
    previewControllerGetSavingsPreviewRaw(requestParameters: PreviewControllerGetSavingsPreviewRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Result>>;

    /**
     */
    previewControllerGetSavingsPreview(requestParameters: PreviewControllerGetSavingsPreviewRequest, initOverrides?: RequestInit): Promise<Result>;

    /**
     *
     * @param {SpecialOfferRequest} specialOfferRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PreviewControllerApiInterface
     */
    previewControllerGetSpecialPreviewRaw(requestParameters: PreviewControllerGetSpecialPreviewRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Result>>;

    /**
     */
    previewControllerGetSpecialPreview(requestParameters: PreviewControllerGetSpecialPreviewRequest, initOverrides?: RequestInit): Promise<Result>;
}

/**
 *
 */
export class PreviewControllerApi extends runtime.BaseAPI implements PreviewControllerApiInterface {

    /**
     */
    async previewControllerGetLoanPreviewRaw(requestParameters: PreviewControllerGetLoanPreviewRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Result>> {
        const queryParameters: any = {};

        if (requestParameters.purpose !== undefined) {
            queryParameters['purpose'] = requestParameters.purpose;
        }

        if (requestParameters.amount !== undefined) {
            queryParameters['amount'] = requestParameters.amount;
        }

        if (requestParameters.creditScore !== undefined) {
            queryParameters['creditScore'] = requestParameters.creditScore;
        }

        if (requestParameters.zipcode !== undefined) {
            queryParameters['zipcode'] = requestParameters.zipcode;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/preview/loans`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async previewControllerGetLoanPreview(requestParameters: PreviewControllerGetLoanPreviewRequest = {}, initOverrides?: RequestInit): Promise<Result> {
        const response = await this.previewControllerGetLoanPreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async previewControllerGetSavingsPreviewRaw(requestParameters: PreviewControllerGetSavingsPreviewRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.savingsOfferRequest === null || requestParameters.savingsOfferRequest === undefined) {
            throw new runtime.RequiredError('savingsOfferRequest','Required parameter requestParameters.savingsOfferRequest was null or undefined when calling previewControllerGetSavingsPreview.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/preview/savings`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.savingsOfferRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async previewControllerGetSavingsPreview(requestParameters: PreviewControllerGetSavingsPreviewRequest, initOverrides?: RequestInit): Promise<Result> {
        const response = await this.previewControllerGetSavingsPreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async previewControllerGetSpecialPreviewRaw(requestParameters: PreviewControllerGetSpecialPreviewRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Result>> {
        if (requestParameters.specialOfferRequest === null || requestParameters.specialOfferRequest === undefined) {
            throw new runtime.RequiredError('specialOfferRequest','Required parameter requestParameters.specialOfferRequest was null or undefined when calling previewControllerGetSpecialPreview.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/preview/special`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.specialOfferRequest,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);

    }
    /**
     */
    async previewControllerGetSpecialPreview(requestParameters: PreviewControllerGetSpecialPreviewRequest, initOverrides?: RequestInit): Promise<Result> {
        const response = await this.previewControllerGetSpecialPreviewRaw(requestParameters, initOverrides);
        return await response.value();
    }
}

/**
 * @export
 * @enum {string}
 */
export type PreviewControllerGetLoanPreviewPurposeEnum = 'debt_consolidation' |'credit_card_refi' |'home_improvement' |'large_purchases' |'auto_purchase' |'auto_refinance' |'baby' |'boat' |'business' |'car_repair' |'cosmetic' |'emergency' |'engagement' |'green' |'home_purchase' |'home_refi' |'household_expenses' |'life_event' |'medical_dental' |'motorcycle' |'moving_relocation' |'rv' |'special_occasion' |'student_loan' |'student_loan_refi' |'taxes' |'vacation' |'wedding' |'other'
/**
 * @export
 * @enum {string}
 */
export type PreviewControllerGetLoanPreviewCreditScoreEnum = 'excellent' |'good' |'fair' |'poor'
